module.exports = __webpack_public_path__ + "static/media/stripe-badge.54a423c8.png";